package org.hs_soft.runmynesto.domain.util

object ApiPath
{
    const val generateDish="images/generate-dish"
    const val getMenuCard="menucards/generate-menu-card"
    const val getDataAssistantAnswer="dataassistant/generate-answer"
    const val saveDataAssistantFavoriteMessages="dataassistant/save-favorite-messages"
    const val getDataAssistantMessageHistory="dataassistant/get-message-history"
    const val getDataAssistantRequestLogMessage="dataassistant/get-request-last-log"
}